import { colors } from '@dexma/ui-components';
import styled from 'styled-components';

export const NewWidgetOverlaySurface = styled.div<{ $containerWidth: number }>`
    position: relative;
    width: ${({ $containerWidth }) => ($containerWidth > 0 ? `${$containerWidth}px` : '100%')};
`;

export const NewWidgetOverlayBox = styled.div`
    position: absolute;
    z-index: 10000;
    pointer-events: none;
    border: 1px dashed ${colors.gray700};
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 0.72);
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const NewWidgetOverlayAction = styled.div`
    pointer-events: auto;
`;
